import { Flex } from '@chakra-ui/react';
import React, { FC } from 'react';
import { MdCheckBox, MdOutlineCheckBoxOutlineBlank } from 'react-icons/md';

interface BoolCellProps {
  value: boolean;
}

const BoolCell: FC<BoolCellProps> = (props) => {
  const { value } = props;
  return (
    <Flex justify='center'>
      {value ? (
        <MdCheckBox fill='var(--chakra-colors-brand-500)' />
      ) : (
        <MdOutlineCheckBoxOutlineBlank fill='var(--chakra-colors-gray-500)' />
      )}
    </Flex>
  );
};


export default BoolCell;
